export default __webpack_public_path__ + "static/media/tech-0-fig6.68241d7e.png";